import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Firestore, collection, collectionData } from '@angular/fire/firestore';

@Component({
  selector: 'app-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.css']
})
export class PanelComponent implements OnInit {

  invitados: any[] = [];
  mensajes: any[] = [];

  constructor(private firestore: Firestore) {}

  ngOnInit(): void {
    this.getInvitados();
    this.getMensajes();
  }

  getInvitados() {
    const ref = collection(this.firestore, 'invitados');
    collectionData(ref, { idField: 'id' }).subscribe(data => {
      this.invitados = data;
    });
  }

  getMensajes() {
    const ref = collection(this.firestore, 'mensajes');
    collectionData(ref, { idField: 'id' }).subscribe(data => {
      this.mensajes = data;
    });
  }
}